import { DOCUMENT_TYPE_DATA } from "../DocumentTypeData";
import type { DocumentTypeConfig, ResolveDocumentTypeDataParams } from "../types";

export const resolveDocumentTypeData = ({
    index,
}: ResolveDocumentTypeDataParams): DocumentTypeConfig | undefined => {
    const key = Object.keys(DOCUMENT_TYPE_DATA).find((datasourceId) =>
        index.includes(datasourceId),
    );
    return key ? DOCUMENT_TYPE_DATA[key] : undefined;
};
